const permission = {
  state: {
    permissionArr: [
      {
        id: 1,
        name: "visitor",
        localSet: "AvAiAsAiAtAoArA",
      }, // 访客（只能看开屏页）
      {
        id: 2,
        name: "fans",
        localSet: "BfBaBnBsB",
      }, // 粉丝（通过密码 n² + n 校验的用户）
      {
        id: 3,
        name: "root",
        localSet: "CrCoCoCtC",
      }, // 最高权限者（输入万能密码[接口返回值 + 1]的用户）
    ], // 权限的列表
  },
};

export default permission;
